// extracted by mini-css-extract-plugin
export default {"teamMember":"TeamMember_teamMember__5xKwr","textDecor":"TeamMember_textDecor__tjPmM"};